module.exports = __webpack_public_path__ + "img/hardyClub1.8e9308fb.png";